import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom"
import Header from "./Header"


function MainLayout() {
  return (
    <>
      <Header />
      <div>
        <Outlet />
      </div>
    </>
  )
}

export default MainLayout